export enum EmailSendEnum {
  RESEND_PASSWORD,
  WELCOME_USER,
  TEST_CAMPAIGN,
  TEST_PROVIDER,
}
